import React, { memo } from 'react';
import PopupContainer from '../../component/popup';
import { IsListNotEmpty } from '../../utils'
import MultiSelect from '../../component/formFields/DropDown/Multiselect'
import { GetRolesLookup, GetUserDetails } from '../../api/endpoints';
import { LoadListDefault, useGet, usePost, useUpdate } from '../../api/hooks';
import InputField from '../../component/formFields/InputField';
import useForm from '../../hooks/useForm';

const modalName = "CUUserModal"

const CUUser = ({ rowId, modalID }) => {

    const { formHandler, onSubmit, onReset } = useForm()
    const { onPost } = usePost(onReset)
    const { onUpdate } = useUpdate(onReset)

    const { result: rolesLookup } = useGet({ ...LoadListDefault, endPoint: GetRolesLookup })

    const { result: userInfo } = useGet({
        ...LoadListDefault,
        params: [rowId],
        allowFetch: IsListNotEmpty(rolesLookup) && !!rowId,
        endPoint: GetUserDetails
    })

    const onApply = () => rowId ? onSubmit(onUpdate) : onSubmit(onPost)

    return (
        <PopupContainer
            name={modalName}
            recordID={rowId}
            title={rowId ? "edit-user" : "adit-user"}
            onApply={onApply}
            resetAllFields={rowId ? undefined : onReset}
            modalID={modalID}
            btnName={rowId ? "Update" : "Save"}
        >

            <InputField formHandler={formHandler} name={"Name"} defaultValue={userInfo?.name} />
            <InputField formHandler={formHandler} name={"UserName"} defaultValue={userInfo?.username} />
            <InputField formHandler={formHandler} name={"Email"} defaultValue={userInfo?.email} />
        </PopupContainer>
    );
}
//<MultiSelect isMulti={false} options={rolesLookup} setSelectedOptions={setRole} selectedOptions={role} label={"Role"} placeholder={"Role"} />

export default memo(CUUser);
